import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "mb-5 d-flex justify-start" }
const _hoisted_6 = { class: "d-flex align-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_device_list = _resolveComponent("device-list")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_PaginateWithCount = _resolveComponent("PaginateWithCount")!
  const _component_attach_firmware_form = _resolveComponent("attach-firmware-form")!
  const _component_device_list_search_form = _resolveComponent("device-list-search-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.i18n.global.t('pages.deviceFirmware.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          (_ctx.updateAuthority)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "error",
                onClick: _ctx.createRequestAndDetachFirmwareToDevices,
                disabled: _ctx.isDetachButtonDisabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detachBtnText), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_device_list, {
        class: "mb-2",
        devices: _ctx.devices,
        isDeviceListLoading: _ctx.isDeviceListLoading,
        onSortChange: _ctx.handleChangeSort,
        onUpdateSelectedItems: _ctx.updateSelectedItems
      }, null, 8, ["devices", "isDeviceListLoading", "onSortChange", "onUpdateSelectedItems"]),
      (_ctx.allDevicesCount > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_combobox, {
                class: "mr-4 combobox",
                label: _ctx.i18n.global.t('pages.deviceFirmware.resultsPerPage'),
                items: _ctx.devicesPerPageVariants,
                modelValue: _ctx.devicesPerPage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.devicesPerPage) = $event)),
                "hide-details": true
              }, null, 8, ["label", "items", "modelValue"]),
              _createVNode(_component_PaginateWithCount, {
                class: "justify-end",
                modelValue: _ctx.currentPage,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
                totalPage: _ctx.totalPage,
                itemsPerPage: _ctx.devicesPerPage,
                allElementsCount: _ctx.allDevicesCount,
                showItemCount: true
              }, null, 8, ["modelValue", "totalPage", "itemsPerPage", "allElementsCount"]),
              _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1))
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_attach_firmware_form, {
        isFirmwareDeviceAttaching: _ctx.isFirmwareDeviceAttaching,
        updateAuthority: _ctx.updateAuthority,
        isAttachButtonDisabled: _ctx.isAttachButtonDisabled,
        availableToSelectFirmwares: _ctx.availableToSelectFirmwares,
        onSendForm: _ctx.createRequestAndAttachFirmwareToDevices
      }, null, 8, ["isFirmwareDeviceAttaching", "updateAuthority", "isAttachButtonDisabled", "availableToSelectFirmwares", "onSendForm"])
    ]),
    _createVNode(_component_device_list_search_form, {
      isDeviceListLoading: _ctx.isDeviceListLoading,
      onFormChange: _ctx.handleChangeSearchForm,
      onSearch: _ctx.resetPaginationAndGetDevices
    }, null, 8, ["isDeviceListLoading", "onFormChange", "onSearch"])
  ]))
}